import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {DEFAULT_PAGE_SIZE} from '../../shared';
import {
  ChangeProjectsPageSizeAction,
  LoadProjectsSuccessAction, OrderProjectsByAction,
  PageProjectsToAction, projectListActionTypes,
  QuickSearchProjectsAction,
  SearchProjectsAction,
  ToggleSearchProjectsAction
} from '../actions/projects-list';

export interface ProjectsState {
  // tslint:disable-next-line:no-any
  array: any[];
  showFilter: boolean;
  quickSearch: string;
  // tslint:disable-next-line:no-any
  filter: any;
  page: number;
  pageSize: number;
  orderBy: string;
  count: number;
}

const initialState: ProjectsState = {
  array: undefined,
  showFilter: false,
  quickSearch: undefined,
  filter: undefined,
  page: 1,
  pageSize: DEFAULT_PAGE_SIZE,
  orderBy: 'created descending',
  count: 0,
};

export function ProjectsReducer(state: ProjectsState = initialState, action: Action): ProjectsState {
  switch (action.type) {
    case projectListActionTypes.TOGGLE_SEARCH:
      return handleToggleSearchAction(state, action);
    case projectListActionTypes.QUICK_SEARCH:
      return handleQuickSearchAction(state, action);
    case projectListActionTypes.SEARCH:
      return handleSearchAction(state, action);
    case projectListActionTypes.PAGE_TO:
      return handlePageToAction(state, action);
    case projectListActionTypes.CHANGE_PAGE_SIZE:
      return handleChangePageSizeAction(state, action);
    case projectListActionTypes.ORDER_BY:
      return handleOrderByAction(state, action);
    case projectListActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case projectListActionTypes.LOAD_FAIL:
      return handleLoadErrorActions(state);
    case projectListActionTypes.CLEAR:
      return handleLoadClearActions();
    default:
      return state;
  }
}

function handleToggleSearchAction(state: ProjectsState, action: ToggleSearchProjectsAction): ProjectsState {
  const newState: ProjectsState = {
    ... state,
    showFilter: action.payload
  };
  return newState;
}

function handleQuickSearchAction(state: ProjectsState, action: QuickSearchProjectsAction): ProjectsState {
  const newState: ProjectsState = {
    ... state,
    quickSearch: action.payload,
    page: 1
  };
  return newState;
}

function handleSearchAction(state: ProjectsState, action: SearchProjectsAction): ProjectsState {
  const newState: ProjectsState = {
    ... state,
    filter: action.payload,
    page: 1
  };
  return newState;
}

function handlePageToAction(state: ProjectsState, action: PageProjectsToAction): ProjectsState {
  const newState: ProjectsState = {
    ... state,
    page: action.payload
  };
  return newState;
}

function handleLoadSuccessAction(state: ProjectsState, action: LoadProjectsSuccessAction): ProjectsState {
  const newState: ProjectsState = {
    ... state,
    array: action.payload.array,
    count: action.payload.count
  };
  return newState;
}

function handleChangePageSizeAction(state: ProjectsState, action: ChangeProjectsPageSizeAction): ProjectsState {
  const newState: ProjectsState = {
    ... state,
    page: 1,
    pageSize: action.payload
  };
  return newState;
}
function handleOrderByAction(state: ProjectsState, action: OrderProjectsByAction): ProjectsState {
  const newState: ProjectsState = {
    ... state,
    orderBy: action.payload
  };
  return newState;
}

function handleLoadClearActions(): ProjectsState {
  const newState: ProjectsState = {
    array: undefined,
    showFilter: false,
    quickSearch: undefined,
    filter: undefined,
    page: 1,
    pageSize: DEFAULT_PAGE_SIZE,
    orderBy: 'created descending',
    count: 0
  };
  return newState;
}

function handleLoadErrorActions(state: ProjectsState): ProjectsState {
  return state;
}

export const projectsSelectors = {
  showFilter: (state: ProjectsState) => _.get(state, 'showFilter', false),
  quickSearch: (state: ProjectsState) => _.get(state, 'quickSearch'),
  filter: (state: ProjectsState) => _.get(state, 'filter'),
  page: (state: ProjectsState) => _.get(state, 'page', 1),
  pageSize: (state: ProjectsState) => _.get(state, 'pageSize', DEFAULT_PAGE_SIZE),
  orderBy: (state: ProjectsState) => _.get(state, 'orderBy'),
  array: (state: ProjectsState) => _.get(state, 'array', []),
  count: (state: ProjectsState) => _.get(state, 'count', 0)
};
